module.exports = __webpack_public_path__ + "img/TECHNOLOGY-JIMNY-1.060a5110.jpg";